export default "__VITE_ASSET__mjMiAOcN__"